import * as React from 'react';
import { formatLedgerDate } from '../../ledger/ledgerInstrument';
import './LedgerDate.scss';

export type LedgerDateProps = {
  /** The date the document takes effect. */
  value?: string | null;
};

/** The Effective column; empty when there is no date. */
export const LedgerDate: React.FC<LedgerDateProps> = ({ value }) => (
  <span className="tree-ledger-cell tree-ledger-cell--effective tree-ledger-date">
    {/* Isolated, so a right-to-left page does not reorder "08 May 2011". */}
    {value && <bdi>{formatLedgerDate(value)}</bdi>}
  </span>
);
